// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { UAAnalogControlFunction } from './UAAnalogControlFunction';
import {
    instanceOfUAAnalogControlFunction,
    UAAnalogControlFunctionFromJSON,
    UAAnalogControlFunctionFromJSONTyped,
    UAAnalogControlFunctionToJSON,
} from './UAAnalogControlFunction';
import type { UAAnalogSensorFunction } from './UAAnalogSensorFunction';
import {
    instanceOfUAAnalogSensorFunction,
    UAAnalogSensorFunctionFromJSON,
    UAAnalogSensorFunctionFromJSONTyped,
    UAAnalogSensorFunctionToJSON,
} from './UAAnalogSensorFunction';
import type { UADiscreteControlFunction } from './UADiscreteControlFunction';
import {
    instanceOfUADiscreteControlFunction,
    UADiscreteControlFunctionFromJSON,
    UADiscreteControlFunctionFromJSONTyped,
    UADiscreteControlFunctionToJSON,
} from './UADiscreteControlFunction';

/**
 * @type UAFunctionFunctionSetInner
 * Any concrete LADS function (nested function sets, device-level function sets of monitored devices).
 * @export
 */
export type UAFunctionFunctionSetInner = UAAnalogControlFunction | UAAnalogSensorFunction | UADiscreteControlFunction;

export function UAFunctionFunctionSetInnerFromJSON(json: any): UAFunctionFunctionSetInner {
    return UAFunctionFunctionSetInnerFromJSONTyped(json, false);
}

export function UAFunctionFunctionSetInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAFunctionFunctionSetInner {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfUAAnalogControlFunction(json)) {
        return UAAnalogControlFunctionFromJSONTyped(json, true);
    }
    if (instanceOfUAAnalogSensorFunction(json)) {
        return UAAnalogSensorFunctionFromJSONTyped(json, true);
    }
    if (instanceOfUADiscreteControlFunction(json)) {
        return UADiscreteControlFunctionFromJSONTyped(json, true);
    }
    return {} as any;
}

export function UAFunctionFunctionSetInnerToJSON(json: any): any {
    return UAFunctionFunctionSetInnerToJSONTyped(json, false);
}

export function UAFunctionFunctionSetInnerToJSONTyped(value?: UAFunctionFunctionSetInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfUAAnalogControlFunction(value)) {
        return UAAnalogControlFunctionToJSON(value as UAAnalogControlFunction);
    }
    if (instanceOfUAAnalogSensorFunction(value)) {
        return UAAnalogSensorFunctionToJSON(value as UAAnalogSensorFunction);
    }
    if (instanceOfUADiscreteControlFunction(value)) {
        return UADiscreteControlFunctionToJSON(value as UADiscreteControlFunction);
    }
    return {};
}

